import axios from 'axios';

export default {
    async getResults(API_URL) {
        const { data } = await axios.get(API_URL);

        return data;
    },
    async postResult(API_URL, data) {
        const { result } = await axios.post(API_URL, data);

        return result;
    }
}